const type = (v, expected) => typeof v === expected;
const isNull = v => v === null;
const isObject = v => !isNull(v) && type(v, 'object') && !Array.isArray(v);
const isEmptyString = v => v === '';
const isUndefined = v => v === undefined;
const isArray = v => Array.isArray(v);
const isEmptyArray = v => isArray(v) ? !v.length : false;
const isEmptyObject = v => isObject(v) ? !Object.keys(v).length : false;
const isEmpty = v => isEmptyString(v) || isNull(v) || isUndefined(v) || isEmptyArray(v) || isEmptyObject(v);
const isDOMElement = v => v instanceof HTMLElement;
const isString = v => type(v, 'string');
const isFunction = v => type(v, 'function');
const isBoolean = v => type(v, 'boolean');

export { isFunction as a, isString as b, isEmptyObject as c, isBoolean as d, isDOMElement as e, isEmpty as f, isArray as i };
